// Turn a snake_case / kebab-case token into a display label.
//   "miami_beach"       → "Miami Beach"
//   "single_family"     → "Single Family"
//   "new_construction"  → "New Construction"
//   "1-3_months"        → "1-3 Months"
// Strings that are already humanized ("Coral Gables") pass through unchanged.
export function humanizeToken(token) {
  if (!token) return '';
  return String(token)
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ')
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1).toLowerCase() : w))
    .join(' ');
}

// Humanize a comma- or array-style list: ["brickell", "downtown_miami"]
// or "brickell, downtown_miami" → "Brickell, Downtown Miami".
export function humanizeList(value) {
  if (!value) return '';
  const parts = Array.isArray(value) ? value : String(value).split(',');
  return parts
    .map((p) => humanizeToken(String(p).trim()))
    .filter(Boolean)
    .join(', ');
}
